import React, { useState, useCallback } from "react";
import { connectOpenBetsList } from "./OpenBetsList.connect";
import OpenBetsItem from "../OpenBetsItem/OpenBetsItem";
import DesktopOpenBetsItem from "../DesktopOpenBetsItem/DesktopOpenBetsItem";
import moment from "moment";
import SVG_DownIcon from "../../assets/images/svgs/chevronDown.svg?react";
import SVG_CheckIcon from "../../assets/images/svgs/check.svg?react";

const OpenBetsList = ({
  timeSettings,
  bets,
  title,
  isEvent,
  redirect,
  isUnmatched,
  cancel,
  sportEventStats,
  cancelAll,
  mobileUIonAll,
  actions,
  elementsParams,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isOrderedByDate, setIsOrderedByDate] = useState(false);
  const [isConsolidate, setIsConsolidate] = useState(false);
  const [isAverage, setIsAverage] = useState(false);
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  const averageBet = (bets) => {
    if (bets[0].is_fancy !== 1) {
      let name = bets[0].selection_name;
      let marketType = bets[0].marketType;
      let calculated = [];
      let stake = 0;
      let stakeLay = 0;
      let odd = [];
      let oddLay = [];
      let profit = 0;
      let profitLay = 0;
      bets.map((oneBet, index) => {
        if (oneBet.is_back !== 1) {
          stakeLay = stakeLay + oneBet.stack;
          oddLay.push(oneBet?.odds);
          profit = oneBet?.profit;
        } else {
          stake = stake + oneBet.stack;
          odd.push(oneBet?.odds);
          profitLay = oneBet?.profit;
        }
      });
      // for (let i = 0; i < odd.length; i++){
      //   odd =
      // }
      let averageOdd =
        (odd.reduce((a, b) => a + b, 0) / odd.length).toFixed(2) * 1;
      let averageOddLay =
        (oddLay.reduce((a, b) => a + b, 0) / oddLay.length).toFixed(2) * 1;

      // profit = (stake * averageOdd - stake).toFixed(2) * 1
      // profitLay = (stakeLay * averageOddLay - stakeLay).toFixed(2) * 1

      return (calculated = [
        {
          stake: stake,
          odds: averageOdd,
          profit: profit,
          name: name,
          marketType: marketType,
        },
        {
          stake: stakeLay,
          odds: averageOddLay,
          profit: profitLay,
          name: name,
          marketType: marketType,
        },
      ]);
      // console.log(stake);
    } else {
      let inningArr = [];
      bets.map((item) => {
        inningArr.push(item);
      });
      return inningArr;
    }
  };

  const calculateProfit = (myBet) => {
    return (myBet?.profit).toFixed(2);
  };

  const transformedBets = useCallback(() => {
    if (width < 1024) return null;

    return bets.reduce((result, bet) => {
      if (bet?.delete_status === 2) return result;
      const eventId = bet.match_id;
      const marketId = bet.market_id;

      // Create event group if it doesn't exist
      if (!result[`group${eventId}`]) {
        result[`group${eventId}`] = {
          name: bet.match_name,
          marketTime: bet.createdAt,
          markets: [],
        };
      }

      // Find or create the market within the event group
      let market = result[`group${eventId}`].markets.find(
        (m) => m.marketId === marketId,
      );

      if (!market) {
        market = {
          marketId: marketId,
          marketType: bet.marketType,
          name: bet.market_name,
          is_fancy: bet.is_fancy,
          selections: [],
        };
        result[`group${eventId}`].markets.push(market);
      }

      // Find or create the selection array for this selection name
      let selectionGroup = market.selections.find(
        (group) => group[0] && group[0].selectionName === bet.selection_name,
      );

      if (!selectionGroup) {
        selectionGroup = [];
        market.selections.push(selectionGroup);
      }

      // Add the bet details to the selection group
      selectionGroup.push({
        ...bet,
        selectionName: bet.is_fancy === 1 ? bet?.odds : bet.selection_name,
        odds: bet?.odds,
        stake: bet.stack,
        profit: calculateProfit(bet),
        isBack: bet.is_back === 1,
      });

      return result;
    }, {});
  }, [bets, width]);

  return width < 1024 || !!mobileUIonAll ? (
    <>
      <div
        id="matched_1"
        className="px-3 py-2 cursor-pointer w-full flex items-center justify-between bg-bg_Secondary rounded "
        onClick={() => setCollapsed(!collapsed)}
      >
        <span className=" text-text_Quaternary text-xs">{title}</span>
        <div
          className={` flex items-center justify-center autoAnimate ${
            collapsed ? "-rotate-180" : ""
          }`}
        >
          <SVG_DownIcon fill={"var(--color-quaternary)"} />
        </div>
      </div>

      {!collapsed && (
        <div className="BetSections w-full origin-top scaleVerticalOpen">
          {bets && bets?.length > 0 ? (
            bets.map((item, index) => {
              if (item?.delete_status === 2) return null;
              return (
                <OpenBetsItem
                  isEvent={isEvent}
                  timeSettings={timeSettings}
                  redirect={redirect}
                  isUnmatched={isUnmatched}
                  bet={item}
                  key={item?.bet_id + index}
                  cancel={cancel}
                />
              );
            })
          ) : (
            <div className="BetSections w-full origin-top scaleVerticalOpen">
              <div className=" w-full text-start font-lato font-medium text-sm bg-bg_Quaternary rounded-md mb-1 px-4  py-3 box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1); text-text_Ternary ">
                You have no {title}.
              </div>
            </div>
          )}
        </div>
      )}
    </>
  ) : (
    <>
      <div
        id="matched_1"
        className="px-3 py-2 cursor-pointer w-full flex items-center justify-between bg-bg_Secondary rounded "
        onClick={() => setCollapsed(!collapsed)}
      >
        <span className=" text-text_Quaternary text-xs">Matched Bets</span>
        <div
          className={` flex items-center justify-center autoAnimate ${
            collapsed ? "-rotate-180" : ""
          }`}
        >
          <SVG_DownIcon fill={"var(--color-quaternary)"} />
        </div>
      </div>

      {!collapsed && (
        <div className="w-full origin-top scaleVerticalOpen">
          {bets && bets.length > 0 ? (
            <>
              <div className=" grid grid-cols-2 gap-1 p-2">
                <div className="flex items-center justify-center gap-2">
                  <div className="inline-flex items-center">
                    <label
                      className="relative flex cursor-pointer items-center rounded-full  bg-bg_Quinary "
                      htmlFor="blue"
                    >
                      <input
                        className="before:content[''] before:bg-bg_Secondary3 rounded-md peer relative  cursor-pointer appearance-none border border-undefined transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-max before:w-max before:-translate-x-2/4 before:-translate-y-2/4 before:opacity-0 before:transition-opacity checked:border-undefined checked:bg-bg_Success hover:before:opacity-10 h-4  w-4"
                        id="blue"
                        type="checkbox"
                        checked={isConsolidate}
                        onChange={() => {
                          setIsConsolidate(!isConsolidate);
                          setIsAverage(false);
                          setIsOrderedByDate(false);
                        }}
                        onClick={() => {
                          setIsConsolidate(!isConsolidate);
                          setIsAverage(false);
                          setIsOrderedByDate(false);
                        }}
                      />
                      {isConsolidate ? (
                        <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-text_Quaternary opacity-0 transition-opacity peer-checked:opacity-100">
                          <SVG_CheckIcon />
                        </span>
                      ) : null}
                    </label>
                  </div>
                  <span className="text-xs w-full text-text_Ternary-new">
                    Consolidated
                  </span>
                </div>
                <div className="flex items-center justify-center gap-2">
                  <div className="inline-flex items-center">
                    <label
                      className="relative flex cursor-pointer items-center rounded-full  bg-bg_Quinary "
                      htmlFor="blue"
                    >
                      <input
                        className="before:content[''] before:bg-bg_Secondary3 rounded-md peer relative  cursor-pointer appearance-none border border-undefined transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-max before:w-max before:-translate-x-2/4 before:-translate-y-2/4 before:opacity-0 before:transition-opacity checked:border-undefined checked:bg-bg_Success hover:before:opacity-10 h-4  w-4"
                        id="blue"
                        type="checkbox"
                        checked={isAverage}
                        onChange={() => {
                          setIsAverage(!isAverage);
                          setIsOrderedByDate(false);
                          setIsConsolidate(false);
                        }}
                        onClick={() => {
                          setIsAverage(!isAverage);
                          setIsOrderedByDate(false);
                          setIsConsolidate(false);
                        }}
                      />
                      {isAverage ? (
                        <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-text_Quaternary opacity-0 transition-opacity peer-checked:opacity-100">
                          <SVG_CheckIcon />
                        </span>
                      ) : null}
                    </label>
                  </div>

                  <span className="text-xs w-full text-text_Ternary-new">
                    Average Odds
                  </span>
                </div>

                <div className="flex items-center justify-center gap-2">
                  <div className="inline-flex items-center">
                    <label
                      className="relative flex cursor-pointer items-center rounded-full  bg-bg_Quinary "
                      htmlFor="blue"
                    >
                      <input
                        className="before:content[''] before:bg-bg_Secondary3 rounded-md peer relative  cursor-pointer appearance-none border border-undefined transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-max before:w-max before:-translate-x-2/4 before:-translate-y-2/4 before:opacity-0 before:transition-opacity checked:border-undefined checked:bg-bg_Success hover:before:opacity-10 h-4  w-4"
                        id="blue"
                        type="checkbox"
                        checked={isOrderedByDate}
                        onChange={() => {
                          setIsOrderedByDate(!isOrderedByDate);
                          setIsAverage(false);
                          setIsConsolidate(false);
                        }}
                        onClick={() => {
                          setIsOrderedByDate(!isOrderedByDate);
                          setIsAverage(false);
                          setIsConsolidate(false);
                        }}
                      />
                      {isOrderedByDate ? (
                        <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-text_Quaternary opacity-0 transition-opacity peer-checked:opacity-100">
                          <SVG_CheckIcon />
                        </span>
                      ) : null}
                    </label>
                  </div>
                  <span className="text-xs w-full text-text_Ternary-new">
                    Order By Date
                  </span>
                </div>
              </div>

              {Object.keys(transformedBets()).length > 0
                ? Object.keys(transformedBets()).map((group) => (
                    <React.Fragment key={transformedBets()[group]?.marketTime}>
                      <div className="flex flex-col gap-1 w-full mb-1">
                        <div className="flex items-center justify-between py-1 border px-2  rounded">
                          <div className="text-text_Ternary-new  font-lato text-sm font-semibold">
                            {transformedBets()[group]?.name}
                          </div>
                          <div className="flex flex-col items-center justify-center uppercase">
                            <span className=" text-[9px] text-text_Ternary ">
                              {moment(
                                transformedBets()[group]?.marketTime,
                              ).format("DD/MM/YYYY")}
                            </span>
                            <span className="text-[9px] text-text_Ternary ">
                              {moment(
                                transformedBets()[group]?.marketTime,
                              ).format("hh:mm:ss A")}
                            </span>
                          </div>
                        </div>

                        {transformedBets()[group].markets.map(
                          (market, index) => {
                            if (market?.delete_status === 2) return null;
                            return (
                              <div key={index}>
                                {!isConsolidate &&
                                  market.is_fancy == 1 &&
                                  !isAverage && (
                                    <div className="text-text_Ternary-new  border font-semibold text-xs px-2 py-1 rounded bg-bg_Ternary8">
                                      {market.name}
                                    </div>
                                  )}

                                {!isConsolidate && !isAverage && (
                                  <div className="grid border grid-cols-6  px-2 py-1 bg-bg_Ternary8 rounded items-center gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                                    <span className="col-span-2 text-text_Ternary-new  font-semibold capitalize">
                                      {market.is_fancy == 1
                                        ? "Runs"
                                        : market.name}
                                    </span>
                                    <span className="col-span-1 text-center text-text_Ternary-new ">
                                      Odds
                                    </span>
                                    <span className="col-span-1 text-center text-text_Ternary-new ">
                                      Stake
                                    </span>
                                    <span className="col-span-2 text-center text-text_Ternary-new ">
                                      P/L
                                    </span>
                                  </div>
                                )}

                                <div className="flex w-full flex-col gap-0.5">
                                  {!isAverage ? (
                                    <>
                                      {isConsolidate ? (
                                        <div className="border p-1 rounded space-y-2">
                                          {market.selections.map(
                                            (selection, index) => {
                                              return (
                                                <div
                                                  key={`consolidated-${index}`}
                                                  className="w-full space-y-0.5"
                                                >
                                                  {selection.map(
                                                    (item, index) => (
                                                      <React.Fragment
                                                        key={item?.bet_id}
                                                      >
                                                        {index === 0 && (
                                                          <>
                                                            <span className="text-text_Ternary-new  border font-semibold text-xs px-2 py-1 rounded bg-bg_Ternary8">
                                                              {item?.is_fancy ==
                                                              1
                                                                ? item?.market_name
                                                                : item.selection_name}
                                                            </span>
                                                            <div className="bg-bg_Ternary8 border rounded py-1 grid grid-cols-12 gap-1 w-full text-xs font-lato capitalize cursor-pointer">
                                                              {market.is_fancy ===
                                                                1 && (
                                                                <span className="col-span-3 text-center text-text_Ternary-new  text-xs ">
                                                                  Runs
                                                                </span>
                                                              )}
                                                              <span className="col-span-3 text-center text-text_Ternary-new  text-xs ">
                                                                Odds
                                                              </span>
                                                              <span className="col-span-3 text-center text-text_Ternary-new  text-xs ">
                                                                Stake
                                                              </span>
                                                              <span
                                                                className={`${
                                                                  market.is_fancy ===
                                                                  1
                                                                    ? "col-span-3"
                                                                    : "col-span-6"
                                                                } text-center text-text_Ternary-new  text-xs `}
                                                              >
                                                                P/L
                                                              </span>
                                                            </div>
                                                          </>
                                                        )}

                                                        <DesktopOpenBetsItem
                                                          isEvent={isEvent}
                                                          timeSettings={
                                                            timeSettings
                                                          }
                                                          redirect={redirect}
                                                          isUnmatched={
                                                            isUnmatched
                                                          }
                                                          bet={item}
                                                          key={
                                                            item?.bet_id + index
                                                          }
                                                          cancel={cancel}
                                                          consolidate={
                                                            isConsolidate
                                                          }
                                                        />
                                                      </React.Fragment>
                                                    ),
                                                  )}
                                                </div>
                                              );
                                            },
                                          )}
                                        </div>
                                      ) : (
                                        market.selections.map(
                                          (selection, index) => {
                                            return (
                                              <div key={"marketSelect" + index}>
                                                {selection.map(
                                                  (item, index) => (
                                                    <DesktopOpenBetsItem
                                                      isEvent={isEvent}
                                                      timeSettings={
                                                        timeSettings
                                                      }
                                                      redirect={redirect}
                                                      isUnmatched={isUnmatched}
                                                      bet={item}
                                                      key={item?.bet_id + index}
                                                      cancel={cancel}
                                                      consolidate={
                                                        isConsolidate
                                                      }
                                                    />
                                                  ),
                                                )}
                                              </div>
                                            );
                                          },
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {market.selections.map(
                                        (selection, index) => {
                                          return (
                                            <DesktopOpenBetsItem
                                              isEvent={isEvent}
                                              timeSettings={timeSettings}
                                              redirect={redirect}
                                              isUnmatched={isUnmatched}
                                              stake={averageBet(selection)}
                                              key={selection?.bet_id + index}
                                              cancel={cancel}
                                              consolidate={false}
                                              isAverage={true}
                                            />
                                          );
                                        },
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </React.Fragment>
                  ))
                : null}
            </>
          ) : (
            <div className="w-full font-medium text-sm bg-bg_Quaternary rounded px-4  py-3 shadow text-text_HeaderDeskNavMenu">
              You have no {title}.
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default connectOpenBetsList()(OpenBetsList);
